<template>
    <div class="page-wrapper">
        <div class="page-header">
            <WidgetToolbar title="Calendar" :icon="require('@/assets/admin-icon/menu/calendar-active.svg')">
                <div class="options">
                    <DropdownButton class="green" @onSubmit="addNew($event, 'selected')" :content="[
                        { name: 'Google Event', value: 'google' },
                        { name: 'Microsoft Event', value: 'microsoft' },
                    ]">
                        Add Event +
                    </DropdownButton>
                    <div v-if="!isCalendarConnected" class="h-spacer"></div>
                    <DropdownButton v-if="!isCalendarConnected" class="blue"
                        @onSubmit="connectCalendar($event, 'selected')" :content="[
                            { name: 'Google Calendar', value: 'google' },
                            { name: 'Microsoft Calendar', value: 'microsoft' },
                        ]">
                        Connect Calendar +
                    </DropdownButton>

                </div>
            </WidgetToolbar>
        </div>
        <div class="page-tab-container">
            <div class="page-calendar-filter">
                <div class="calendar-left-filter row">
                    <div v-if="false" class="search-wrapper">
                        <widgetSearch class="search-account" placeholder="Search here..." icon="right"
                            @focus="searchFocused" @input="handleSearchInput" v-model="searchQuery">
                        </widgetSearch>
                        <div v-if="showSearchResults && filteredResults.length" class="search-results">
                            <ul>
                                <li v-for="item in filteredResults" :key="item.id"
                                    @click="handleSearchResultClick(item)">
                                    <span class="result-icon">📅</span>
                                    <div class="result-details">
                                        <span class="result-name">{{ item.name }}</span>
                                        <span class="result-date">{{ item.date }}</span>
                                    </div>
                                    <span class="result-type">{{ item.type }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="false" class="v-line-divider" style="height: 40px"></div>

                    <widgetDropdown v-model="showViewFilter" class="option-item" :right="true" :hover="false"
                        :interactive="true">
                        <button class="btn-dropdown">
                            <span v-if="selectedViewLabel">{{ selectedViewLabel }}</span>
                            <span v-else>Change view</span>
                            <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                        </button>
                        <div slot="dropdown" class="dropdown-widget right">
                            <a class="dropdown-item" href="#" v-for="(item, index) in viewFilterOptions"
                                @click="onChangeCalendarView(item)">
                                {{ item.label }}
                            </a>
                        </div>
                    </widgetDropdown>
                </div>
                <div class="calendar-right-filter row">
                    <div class="filter-label">
                        <span>Filter:</span>
                    </div>
                    <widgetDropdown v-model="showEventFilter" class="option-item" style="width:145px" :right="true"
                        :hover="false" :interactive="true">
                        <button class="btn-dropdown">
                            <span v-if="selectedEventLabel">{{ selectedEventLabel }}</span>
                            <span v-else>Event Type</span>
                            <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                        </button>
                        <div slot="dropdown" class="dropdown-widget right">
                            <a class="dropdown-item" href="#" v-for="(item, index) in eventFilterOptions"
                                @click="onChangeCalendarEvent(item)">
                                {{ item.label }}
                            </a>
                        </div>
                    </widgetDropdown>
                </div>
            </div>
            <div class="page-calendar-widget">
                <FullCalendar class="calendar-widget" :options='calendarOptions' ref="fullCalendar">
                    <template v-slot:eventContent='arg'>
                        <div class="calendar-event">
                            <div class="calendar-event-type"
                                :style="{ backgroundColor: arg.event.extendedProps.bgColor, color: arg.event.extendedProps.txtColor }">
                                {{ arg.event.extendedProps.label }}
                            </div>
                            <div class="calendar-event-content">
                                <b v-if="arg.event.extendedProps.type != 'tasks' && arg.event.extendedProps.type != 'leads'"
                                    class="calendar-event-time">
                                    {{ moment(arg.event.extendedProps.start).format('h:mm a') }}
                                    -
                                    {{ moment(arg.event.extendedProps.end).format('h:mm a') }}</b>
                                <i class="calendar-event-title">{{ arg.event.title }}</i>
                            </div>
                        </div>
                    </template>
                </FullCalendar>
            </div>
        </div>

        <add-event-modal v-if="showAddEventModal" :type="platform_event_type" :selected-date="selectedDateInfo"
            @success="showAddEventModal = false, selectedDateInfo = null, getCalendarEvents()"
            @close="showAddEventModal = false, selectedDateInfo = null"></add-event-modal>

    </div>
</template>
<script>
import { eventBus } from "@/main";
import FullCalendar from '@fullcalendar/vue'
import monthGridPlugin from "@fullcalendar/multimonth";
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from '@fullcalendar/interaction'
import addEventModal from "./models/addEventModal.vue";
import { CALENDAR_SEARCH_EVENTS } from "@/Store/Actions/calendar";
import moment from "moment";

export default {
    components: {
        FullCalendar,
        addEventModal
    },
    data: function () {
        return {
            calendarOptions: {
                plugins: [monthGridPlugin, dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
                initialView: 'dayGridMonth',
                events: [],
                editable: true,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                select: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                eventAdd: this.handleEventAdd,
                eventChange: this.handleEventChange,
                eventRemove: this.handleEventRemove,
            },
            searchQuery: '',
            apiSearchResults: [],
            isLoadingSearch: false,
            showSearchResults: false,
            filterForm: {
                event_type: 'all',
            },
            // ============ View ============
            selectedView: 'dayGridMonth',
            showViewFilter: false,
            viewFilterOptions: [
                { label: 'Year View', value: 'multiMonthYear' },
                { label: 'Month View', value: 'dayGridMonth' },
                { label: 'Week View', value: 'dayGridWeek' },
                { label: 'Day View', value: 'timeGridDay' },
            ],
            // ============ Filter ============
            selectedEvent: '',
            showEventFilter: false,
            eventFilterOptions: [
                { label: 'All', value: 'all' },
                { label: 'Tasks', value: 'tasks' },
                { label: 'Leads', value: 'leads' },
                { label: 'Google Event', value: 'google' },
                { label: 'Microsoft Event', value: 'microsoft' },
                // { label: 'Lia', value: 'lia' },
            ],
            showAddEventModal: false,
            platform_event_type: '',
            isCalendarConnected: false,
            selectedDateInfo: null,
        };
    },
    mounted() {
        let vm = this;
        let platform = vm.$route.query.platform;
        if (platform == 'google') {
            vm.$notify({
                group: 'status',
                title: 'Info',
                text: 'Google Calendar connected',
                type: 'info',
                duration: 3000,
            });
        }
        vm.checkCalendarConnected();

    },
    computed: {
        selectedViewLabel() {
            let vm = this;
            return vm.selectedView ? vm.viewFilterOptions.find((item) => item.value === vm.selectedView).label : null;
        },
        selectedEventLabel() {
            let vm = this;
            return vm.filterForm.event_type ? vm.eventFilterOptions.find((item) => item.value === vm.filterForm.event_type).label : null;
        },
        filteredResults() {
            let vm = this;
            if (!vm.searchQuery) {
                return vm.apiSearchResults;
            }
            return vm.apiSearchResults.filter(item =>
                item.name.toLowerCase().includes(vm.searchQuery.toLowerCase())
            );
        }
    },
    methods: {
        checkCalendarConnected() {
            let vm = this;
            vm.isCalendarConnected = vm.$getLoggedUser().calendar_connected;
            vm.getCalendarEvents();
        },
        async handleSearchInput(query) {
            this.searchQuery = query;
            if (!query || query.trim() === '') {
                this.showSearchResults = false;
                this.apiSearchResults = [];
                return;
            }
            this.showSearchResults = true;
            this.isLoadingSearch = true;
            try {
                const response = await this.$store.dispatch(CALENDAR_SEARCH_EVENTS, { query: this.searchQuery });
                this.apiSearchResults = response.data.map(item => ({
                    id: item.id,
                    name: item.title || item.name,
                    date: item.start_date || item.date,
                    type: item.event_type || item.type,
                }));
            } catch (error) {
                console.error("Error searching calendar events:", error);
                this.apiSearchResults = [];
                this.$notify({
                    group: 'status',
                    title: 'Error',
                    text: 'Failed to search events.',
                    type: 'error',
                    duration: 3000,
                });
            } finally {
                this.isLoadingSearch = false;
            }
        },
        searchFocused() {
            this.showSearchResults = this.apiSearchResults.length > 0;
        },
        handleSearchResultClick(item) {
            let vm = this;
            vm.showSearchResults = false;
            vm.searchQuery = item.name;
            let calendarApi = vm.$refs.fullCalendar.getApi();
            calendarApi.gotoDate(item.date);
        },
        handleDateSelect(info) {
            let vm = this;
            // info contains: start, end, startStr, endStr, allDay, view, jsEvent
            // Set the selected date info to pass to the modal
            vm.selectedDateInfo = {
                start: info.start,
                end: info.end,
                allDay: info.allDay
            };
            // Default to google event type for date selection
            vm.platform_event_type = 'google';
            // Open the add event modal
            vm.showAddEventModal = true;
        },
        handleEventClick(info) {
            let vm = this;
            if (info.event.extendedProps.type == 'google') {
                if (info.event.extendedProps.meetLink) {
                    window.open(info.event.extendedProps.meetLink, "_blank");
                }
            }
        },
        handleEventAdd(info) {
            let vm = this;
        },
        handleEventChange(info) {
            let vm = this;
        },
        handleEventRemove(info) {
            let vm = this;
        },
        addNew(type) {
            let vm = this;
            vm.platform_event_type = type;
            vm.selectedDateInfo = null; // Clear any previously selected date
            vm.showAddEventModal = true;
        },
        connectCalendar(type) {
            let vm = this;
            if (type == 'google') {
                vm.signInBySocial('google');
            } else if (type == 'microsoft') {
                vm.signInBySocial('microsoft');
            }
        },
        switchAccount(type) {
            let vm = this;
            if (type == 'google') {
                vm.signInBySocial('google');
            } else if (type == 'microsoft') {
                vm.signInBySocial('microsoft');
            }
        },
        signInBySocial(sign_type) {
            let vm = this;
            if (sign_type == "linkedin") {
                this.$store
                    .dispatch("AUTH_LINKEDIN_SIGNUP_REQUEST", {})
                    .then((responce) => {
                        vm.loading = false;
                    });
            } else if (sign_type == "google") {
                this.$store
                    .dispatch("AUTH_GOOGLE_SIGNUP_REQUEST", {
                        data: {
                            browser_path: "/crm?path=/calendar?platform=google",
                            task: "list_events",
                            consultified_token: vm.$getLoggedUser().consultified_token,
                        },
                        canRedirect: false,

                    })
                    .then((responce) => {
                        vm.loading = false;
                        const authUrl = responce.data.url;
                        // open in new tab
                        window.open(authUrl, "_blank");
                    });
            } else if (sign_type == "facebook") {
                this.$store
                    .dispatch("AUTH_FACEBOOK_SIGNUP_REQUEST", {})
                    .then((responce) => {
                        vm.loading = false;
                    });
            } else if (sign_type == "microsoft") {
                this.$store
                    .dispatch("AUTH_MICROSOFT_SIGNUP_REQUEST", {})
                    .then((responce) => {
                        vm.loading = false;
                    });
            }
        },
        onChangeCalendarView(item) {
            let vm = this;
            vm.showViewFilter = false;
            vm.selectedView = item.value;
            let calendarApi = this.$refs.fullCalendar.getApi();
            calendarApi.changeView(item.value)
        },
        getCalendarEvents() {
            let vm = this;
            vm.$store
                .dispatch("CALENDAR_GET_EVENTS", vm.filterForm)
                .then((response) => {
                    vm.calendarOptions.events = response.data.map((item) => {
                        if (item.type == 'tasks') {
                            let start = new Date(item.end);
                            let end = vm.moment(start).add(1, 'hours').toDate();
                            return {
                                title: item.data.name,
                                start: start,
                                extendedProps: {
                                    label: 'Task',
                                    start: start,
                                    end: end,
                                    type: 'tasks',
                                    bgColor: '#0884AF2E',
                                    txtColor: '#0884AF'
                                }
                            };
                        } else if (item.type == 'leads') {
                            let start = new Date(item.end);
                            let end = vm.moment(start).add(1, 'hours').toDate();
                            return {
                                title: item.data.name,
                                start: start,
                                extendedProps: {
                                    label: 'Lead',
                                    start: start,
                                    end: end,
                                    type: 'leads',
                                    bgColor: '#FF961B1A',
                                    txtColor: '#FF961B'
                                }
                            };
                        } else if (item.type == 'google') {
                            return {
                                title: item.data.summary,
                                start: new Date(item.data.start.date ? item.data.start.date : item.data.start.dateTime),
                                extendedProps: {
                                    label: 'Google Event',
                                    start: new Date(item.data.start.date ? item.data.start.date : item.data.start.dateTime),
                                    end: new Date(item.data.end.date ? item.data.end.date : item.data.end.dateTime),
                                    type: 'google',
                                    meetLink: item.data.hangoutLink,
                                    bgColor: '#FF961B1A',
                                    txtColor: '#FF961B'
                                }
                            };
                        }
                        else {
                            return null
                        }

                    }).filter((item) => item !== null);

                })
                .catch((error) => {

                });
        },
        onChangeCalendarEvent(item) {
            let vm = this;
            vm.showEventFilter = false;
            vm.selectedEvent = item.value;
            vm.filterForm.event_type = item.value;
            vm.getCalendarEvents();
        }
    },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #ebebeb;
    padding: 5px;

    .page-header {
        height: 50px;
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 5px;

        .options {
            display: flex;
            align-items: center;

            .search-account {
                width: 250px;
            }

            .btn-add {
                margin-left: 20px;
            }
        }
    }

    .page-tab-container {
        display: flex;
        flex-direction: column;
        height: calc(100% - 55px);
        background: #fff;
        border-radius: 5px;
        padding: 10px;

        .page-calendar-filter {
            height: 50px;
            background-color: #fff;
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .calendar-left-filter {
                display: flex;
                align-items: center;
            }

            .search-wrapper {
                position: relative;
                width: 250px;

                .search-account {
                    width: 100%;
                }

                .search-results {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    right: 0;
                    background-color: #fff;
                    border: 1px solid #ddd;
                    border-top: none;
                    max-height: 200px;
                    overflow-y: auto;
                    z-index: 1000;
                    border-radius: 0 0 4px 4px;

                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;

                        li {
                            padding: 10px 12px;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            border-bottom: 1px solid #eee;

                            &:last-child {
                                border-bottom: none;
                            }

                            &:hover {
                                background-color: #f0f0f0;
                            }

                            .result-icon {
                                margin-right: 10px;
                                font-size: 1.2em;
                            }

                            .result-details {
                                display: flex;
                                flex-direction: column;
                                flex-grow: 1;

                                .result-name {
                                    font-weight: bold;
                                    color: #333;
                                }

                                .result-date {
                                    font-size: 0.9em;
                                    color: #666;
                                }
                            }

                            .result-type {
                                font-size: 0.9em;
                                color: #888;
                                background-color: #e9e9e9;
                                padding: 3px 6px;
                                border-radius: 3px;
                                margin-left: 10px;
                            }
                        }
                    }
                }
            }

            .option-item {
                border: 1px solid #ddd;
                height: 30px;
                padding: 0px 7px;
                display: flex;
                align-items: center;
                border-radius: 4px;
            }

            .calendar-right-filter {
                .filter-label {
                    margin-right: 10px;
                }
            }
        }

        .page-calendar-widget {
            height: calc(100% - 58px);
            background-color: #fff;
            border-radius: 5px;
            padding: 10px;
            overflow-y: auto;

            .calendar-widget {
                height: 100%;
                display: flex;
                flex-direction: column;

                .calendar-event {
                    display: flex;
                    flex-direction: column;
                    padding: 5px;
                    border-radius: 5px;
                    background-color: #f5f5f5;
                    margin-bottom: 5px;

                    .calendar-event-type {
                        padding: 5px 10px;
                        border-radius: 5px;
                        margin-bottom: 8px;

                        &.tasks {
                            background-color: #0884AF2E;
                            color: #0884AF;
                        }
                    }

                    .calendar-event-content {
                        display: flex;
                        align-items: center;

                        .calendar-event-time {
                            margin-right: 10px;
                        }

                        .calendar-event-title {
                            font-style: italic;
                        }
                    }


                }
            }
        }
    }

}

.vdp-datepicker__calendar {
    right: 0px;
}
</style>

<style lang="scss">
.page-calendar-filter {
    .vdp-datepicker__calendar {
        right: 0px;
    }
}

.page-calendar-widget {
    .fc {
        .fc-daygrid-day.fc-day-today {
            background-color: #ffffff !important;

            .fc-daygrid-day-top {
                .fc-daygrid-day-number {
                    background: #1ba5a4;
                    color: #fff;
                    border-radius: 50%;
                    height: 34px;
                    width: 34px;
                    margin: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }

        .fc-col-header-cell.fc-day.fc-day-today {
            background: #1ba5a4 !important;

            a {
                color: #fff;
            }
        }

        .fc-daygrid-day-frame {
            min-height: 100px;
            position: relative;
        }
    }

    .fc-event-today {
        .calendar-event-time {
            color: #121212 !important;
        }

        .calendar-event-title {
            color: #121212 !important;
        }
    }
}
</style>